<template>
  <hr class="el_c-divider">
</template>

<script>
  export default {
    name: 'el-divider',
  };
</script>
